String.prototype.toStudlyCase = function () {
    return this.trim() //remove first spaces
        .replace(/([^a-zA-Z\d].)/g, function (t) {//get
            return t.toUpperCase()
                .replace(/[^a-zA-Z\d]/g, '');
        });
};

String.prototype.toDatasetName = function () {
    return this.startsWith('data-')
        ? this.substr(5).toStudlyCase()
        : this.toStudlyCase();
};

// TODO: Check the importance of this method. Or add mode detail information.
// helper method to get string as selector, by adding (#) to the beginning if it's not start with one.
String.prototype.toSelector = function () {
    // todo:: add html tags if it's needed.
    return this.trim().startsWith(".") || this.trim().startsWith("#")
        ? this.toString()
        : "#" + this.toString();
};

String.prototype.replaceArray = function (find:string, replace:string) {
    var replaceString = this;
    var regex:RegExp;
    for (var i = 0; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        replaceString = replaceString.replace(regex, replace[i]);
    }
    return replaceString;
};

String.prototype.rtrim = function (s?:string) {
    if (s === undefined)
        s = '\\s';
    return this.replace(new RegExp("[" + s + "]*$"), '');
};

String.prototype.ltrim = function (s?:string) {
    if (s === undefined)
        s = '\\s';
    return this.replace(new RegExp("^[" + s + "]*"), '');
};

String.prototype.digitsOnly = function () {
    return Salla.helpers.digitsOnly(this);
};